import React, {

    useEffect,

    useMemo,

    useState,

} from 'react'

import api from '../components/api'

import MaterialReactTable from 'material-react-table'

import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR'

import { useQuery } from 'react-query'

import moment from 'moment'

import { useVerificaDesafioContext } from '../context/verificaDesafioContext'

const Pendencias = (props) => {

    const desafio = props.desafio

    // =========================================================

    // FILTROS

    // =========================================================

    const [ano, setAno] = useState('')

    const [

        adesao_institucional_id,

        setAdesaoInstitucionalId

    ] = useState('')

    // =========================================================

    // ANOS

    // =========================================================

    const anoAtual = moment().year()

    const listaAnos = Array.from(

        {

            length: anoAtual - 2020 + 1

        },

        (_, index) => anoAtual - index

    )

    const { verificaDesafio } = useVerificaDesafioContext()

    // =========================================================

    // CONSULTA PENDÊNCIAS

    // =========================================================

    const {

        data: resultado,

        isLoading,

        isFetching,

        refetch,

    } = useQuery({

        queryKey: [

            'pendenciasCorrigidas',

            desafio,

            ano,

            adesao_institucional_id,

        ],

        queryFn: async () => {

            try {

                const dataPost = {

                    desafio:

                        desafio || null,

                    ano:

                        ano !== ''

                            ? Number(ano)

                            : null,

                    adesao_institucional_id:

                        adesao_institucional_id !== ''

                            ? Number(adesao_institucional_id)

                            : null,

                }

                const result = await api.post(

                    'pendenciasCorrigidas',

                    dataPost

                )

                return result.data ?? []

            } catch (err) {

                console.log(err.response)

                throw err

            }

        },

        keepPreviousData: true,

    })

    // =========================================================

    // ATUALIZA CONSULTA QUANDO HOUVER ALTERAÇÃO NO DESAFIO

    // =========================================================

    useEffect(() => {

        if (verificaDesafio) {

            refetch()

        }

    }, [

        verificaDesafio,

        refetch

    ])

    // =========================================================

    // TOTAL DE PENDÊNCIAS

    // =========================================================

    const totalPendencias = useMemo(() => {

        return (resultado ?? []).reduce(

            (total, item) =>

                total + Number(item.total || 0),

            0

        )

    }, [resultado])

    // =========================================================

    // ATUALIZA TOTAL DE NOTIFICAÇÕES NO COMPONENTE PAI

    // =========================================================

    useEffect(() => {

        if (props.setTotalNotificacoes) {

props.setTotalNotificacoes(

                totalPendencias

            )

        }

    }, [

        totalPendencias,

props.setTotalNotificacoes

    ])

    // =========================================================

    // TOTAL DE HOSPITAIS

    // =========================================================

    const totalHospitais = useMemo(() => {

        const hospitais = new Set(

            (resultado ?? []).map(

item =>

item.adesao_institucional_id

            )

        )

        return hospitais.size

    }, [resultado])

    // =========================================================

    // ABRIR PENDÊNCIA
    //
    // O componente Pendencias não abre mais nenhum modal.
    // A tela pai recebe o item clicado através de props.abrirModal
    // e decide qual modal abrir.
    // =========================================================

    const abrirPendencia = (row) => {

        const item = row.original

        if (typeof props.abrirModal === 'function') {

            props.abrirModal(item)

        }

    }

    // =========================================================

    // COLUNAS

    // =========================================================

    const columns = useMemo(

        () => [

            // =================================================

            // HOSPITAL

            // =================================================

            {

                accessorKey: 'nome_fantasia',

                id: 'nome_fantasia',

                header: 'Hospital',

                size: 280,

                Cell: ({ row }) => (

                    <div>

                        <div

style={{

                                fontWeight: 600,

                                color: '#333',

                            }}

                        >

                            {row.original.nome_fantasia}

                        </div>

                    </div>

                ),

            },

            // =================================================

            // CNPJ

            // =================================================

            {

                accessorKey: 'cnpj',

                id: 'cnpj',

                header: 'CNPJ',

                size: 130,

            },

            // =================================================

            // ANO

            // =================================================

            {

                accessorKey: 'ano',

                id: 'ano',

                header: 'Ano',

                size: 70,

                muiTableHeadCellProps: {

                    align: 'center',

                },

                muiTableBodyCellProps: {

                    align: 'center',

                },

            },

            // =================================================

            // SEÇÃO

            // =================================================

            {

                accessorKey: 'secao',

                id: 'secao',

                header: 'Seção',

                size: 230,

                Cell: ({ cell }) => (

                    <span

style={{

                            fontWeight: 500,

                        }}

                    >

                        {cell.getValue()}

                    </span>

                ),

            },

            // =================================================

            // ÚLTIMA ALTERAÇÃO

            // =================================================

            {

                accessorKey: 'ultimaAlteracao',

                id: 'ultimaAlteracao',

                header: 'Última correção',

                size: 160,

                Cell: ({ cell }) => {

                    const valor =

cell.getValue()

                    if (!valor) {

                        return '-'

                    }

                    return (

                        <div

style={{

                                whiteSpace: 'nowrap',

                            }}

                        >

                            <i

className="fa fa-clock-o"

style={{

                                    marginRight: 5,

                                    color: '#777',

                                }}

                            />

                            {valor}

                        </div>

                    )

                },

            },

            // =================================================

            // TOTAL

            // =================================================

            {

                accessorKey: 'total',

                id: 'total',

                header: 'Pendências',

                size: 100,

                muiTableHeadCellProps: {

                    align: 'center',

                },

                muiTableBodyCellProps: {

                    align: 'center',

                },

                Cell: ({ cell }) => (

                    <span

className="badge badge-warning"

style={{

                            fontSize: '11px',

                            padding: '5px 9px',

                        }}

                    >

                        {cell.getValue()}

                    </span>

                ),

            },

        ],

        []

    )

    // =========================================================

    // LIMPAR FILTROS

    // =========================================================

    const limparFiltros = () => {

        setAno('')

        setAdesaoInstitucionalId('')

    }

    // =========================================================

    // RETURN

    // =========================================================

    return (

        <>

            <div

style={{

                    marginTop: 10

                }}

            >

                {/* =================================================

                    RESUMO

                ================================================= */}

                <div

className="row"

style={{

                        marginBottom: 20,

                    }}

                >

                    {/* =============================================

                        TOTAL PENDÊNCIAS

                    ============================================= */}

                    <div

className="col-md-6 col-sm-12"

                    >

                        <div

style={{

                                border: '1px solid #e5e5e5',

                                borderRadius: 6,

                                padding: '16px 20px',

                                backgroundColor: '#fff',

                                minHeight: 90,

                                display: 'flex',

                                alignItems: 'center',

                                justifyContent: 'space-between',

                            }}

                        >

                            <div>

                                <div

style={{

                                        fontSize: '11px',

                                        color: '#777',

                                        textTransform: 'uppercase',

                                        fontWeight: 600,

                                        letterSpacing: '0.3px',

                                    }}

                                >

                                    Correções aguardando análise

                                </div>

                                <div

style={{

                                        fontSize: '12px',

                                        color: '#999',

                                        marginTop: 4,

                                    }}

                                >

                                    Total de pendências corrigidas

                                </div>

                            </div>

                            <div

style={{

                                    display: 'flex',

                                    alignItems: 'center',

                                    gap: 12,

                                }}

                            >

                                <div

style={{

                                        width: 46,

                                        height: 46,

                                        borderRadius: '50%',

                                        display: 'flex',

                                        alignItems: 'center',

                                        justifyContent: 'center',

                                        backgroundColor: '#fff3cd',

                                        color: '#d58512',

                                        fontSize: 20,

                                    }}

                                >

                                    <i

className="fa fa-exclamation-triangle"

                                    />

                                </div>

                                <div

style={{

                                        fontSize: '30px',

                                        fontWeight: 600,

                                        color: '#d58512',

                                        lineHeight: 1,

                                        minWidth: 40,

                                        textAlign: 'right',

                                    }}

                                >

                                    {totalPendencias}

                                </div>

                            </div>

                        </div>

                    </div>

                    {/* =============================================

                        TOTAL HOSPITAIS

                    ============================================= */}

                    <div

className="col-md-6 col-sm-12"

                    >

                        <div

style={{

                                border: '1px solid #e5e5e5',

                                borderRadius: 6,

                                padding: '16px 20px',

                                backgroundColor: '#fff',

                                minHeight: 90,

                                display: 'flex',

                                alignItems: 'center',

                                justifyContent: 'space-between',

                            }}

                        >

                            <div>

                                <div

style={{

                                        fontSize: '11px',

                                        color: '#777',

                                        textTransform: 'uppercase',

                                        fontWeight: 600,

                                        letterSpacing: '0.3px',

                                    }}

                                >

                                    Hospitais

                                </div>

                                <div

style={{

                                        fontSize: '12px',

                                        color: '#999',

                                        marginTop: 4,

                                    }}

                                >

                                    Instituições com correções pendentes

                                </div>

                            </div>

                            <div

style={{

                                    display: 'flex',

                                    alignItems: 'center',

                                    gap: 12,

                                }}

                            >

                                <div

style={{

                                        width: 46,

                                        height: 46,

                                        borderRadius: '50%',

                                        display: 'flex',

                                        alignItems: 'center',

                                        justifyContent: 'center',

                                        backgroundColor: '#e8f2fb',

                                        color: '#337ab7',

                                        fontSize: 20,

                                    }}

                                >

                                    <i

className="fa fa-hospital-o"

                                    />

                                </div>

                                <div

style={{

                                        fontSize: '30px',

                                        fontWeight: 600,

                                        color: '#337ab7',

                                        lineHeight: 1,

                                        minWidth: 40,

                                        textAlign: 'right',

                                    }}

                                >

                                    {totalHospitais}

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

                {/* =================================================

                    FILTROS

                    Mantidos comentados conforme arquivo atual.

                ================================================= */}

                <div

className="row"

style={{

                        marginBottom: 15,

                    }}

                >

                    {/* ANO

                    <div className="col-md-2 col-sm-4">

                        <div className="form-group">

                            <label className="control-label">

                                Ano

                            </label>

                            <select

                                className="form-control"

                                value={ano}

                                onChange={event =>

                                    setAno(event.target.value)

                                }

                            >

                                <option value="">

                                    Todos

                                </option>

                                {listaAnos.map(item => (

                                    <option

                                        key={item}

                                        value={item}

                                    >

                                        {item}

                                    </option>

                                ))}

                            </select>

                        </div>

                    </div>

                    */}

                    {/* HOSPITAL

                    <div className="col-md-3 col-sm-6">

                        <div className="form-group">

                            <label className="control-label">

                                Código Hospital

                            </label>

                            <input

                                type="number"

                                className="form-control"

                                placeholder="Adesão institucional"

                                value={adesao_institucional_id}

                                onChange={event =>

                                    setAdesaoInstitucionalId(

                                        event.target.value

                                    )

                                }

                            />

                        </div>

                    </div>

                    */}

                    {/* LIMPAR

                    <div className="col-md-2 col-sm-4">

                        <div className="form-group">

                            <label className="control-label">

                                 

                            </label>

                            <button

                                type="button"

                                className="btn btn-default btn-block"

                                onClick={limparFiltros}

                            >

                                <i className="fa fa-eraser" />

                                {' '}

                                Limpar

                            </button>

                        </div>

                    </div>

                    */}

                </div>

                {/* =================================================

                    CABEÇALHO DA TABELA / ATUALIZAÇÃO

                ================================================= */}

                <div

style={{

                        marginBottom: 10,

                        display: 'flex',

                        alignItems: 'center',

                        justifyContent: 'space-between',

                        gap: 10,

                    }}

                >

                    <div>

                        <strong>

                            Pendências corrigidas

                        </strong>

                        {' — '}

                        <span

style={{

                                color: '#777',

                            }}

                        >

                            {desafio}

                        </span>

                    </div>

                    <button

type="button"

className="btn btn-primary"

disabled={isFetching}

onClick={() => refetch()}

style={{

                            padding: '6px 12px',

                            fontSize: '13px',

                            lineHeight: '1.3',

                            whiteSpace: 'nowrap',

                        }}

                    >

                        <i

className={

                                isFetching

                                    ? 'fa fa-refresh fa-spin'

                                    : 'fa fa-refresh'

                            }

style={{

                                marginRight: 6,

                            }}

                        />

                        {

                            isFetching

                                ? 'Atualizando...'

                                : 'Atualizar correções'

                        }

                    </button>

                </div>

                {/* =================================================

                    TABELA

                ================================================= */}

                <MaterialReactTable

columns={columns}

data={resultado ?? []}

localization={

                        MRT_Localization_PT_BR

                    }

enableColumnResizing

                    // =============================================

                    // ESTADO INICIAL

                    // =============================================

initialState={{

                        density: 'compact',

                        pagination: {

                            pageSize: 25,

                            pageIndex: 0,

                        },

                        sorting: [

                            {

                                id: 'ultimaAlteracao',

                                desc: true,

                            }

                        ],

                    }}

                    // =============================================

                    // PAGINAÇÃO

                    // =============================================

paginationDisplayOptions={{

                        showPageSizeSelect: false,

                    }}

                    // =============================================

                    // LOADING

                    // =============================================

state={{

                        isLoading,

                        showProgressBars:

                            isLoading || isFetching,

                    }}

                    // =============================================

                    // CABEÇALHO

                    // =============================================

muiTableHeadCellProps={{

                        sx: {

                            fontSize: '11px',

                            py: 0.5,

                            px: 0.8,

                            backgroundColor: '#337ab7',

                            color: '#fff',

                            whiteSpace: 'normal',

                            wordBreak: 'break-word',

                        },

                    }}

                    // =============================================

                    // CÉLULAS

                    // =============================================

muiTableBodyCellProps={{

                        sx: {

                            fontSize: '11px',

                            py: 0.5,

                            px: 0.8,

                            whiteSpace: 'normal',

                            wordBreak: 'break-word',

                            lineHeight: 1.2,

                        },

                    }}

                    // =============================================

                    // LINHA

                    // =============================================

muiTableBodyRowProps={({ row }) => ({

                        sx: {

                            cursor: 'pointer',

                            '&:hover': {

                                backgroundColor: '#f5f5f5',

                            },

                        },

                        onClick: () => {

                            abrirPendencia(row)

                        },

                    })}

                />

            </div>

        </>

    )

}

export default Pendencias
